import { Link } from "react-router-dom";
import { Wand2, Route, ListChecks, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { PageTitle, AdminButton, useList } from "@/components/admin/kit";
import { useAuth, can } from "@/lib/auth";
import { useTerms } from "@/lib/industry";

export default function AdminEditor() {
  const [all, reload] = useList("/admin/house-types");
  const [spots] = useList("/admin/hotspots");
  const { user } = useAuth();
  const { t, sells } = useTerms();
  const content = can(user, "content");
  if (!all) return null;
  const count = (h) => (spots || []).filter((s) => s.house_type_id === h.id).length;
  const del = async (h) => {
    const what = h.kind === "scan" || !sells ? "tour" : "home";
    if (!window.confirm(`Delete the ${what} "${h.name}"? Its ${count(h)} hotspots and guided tour are deleted too. This can't be undone.`)) return;
    try { await api.delete(`/admin/house-types/${h.id}`); toast.success(`"${h.name}" deleted`); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const names = all.map((h) => h.name.trim().toLowerCase());
  return (
    <div data-testid="admin-editor-hub">
      <PageTitle help="editor" title="3D editor" sub="Place hotspots and build guided tours inside your Matterport tours. The 3D view loads on your published site." />
      <div className="space-y-3">
        {all.map((h) => {
          const dup = names.filter((n) => n === h.name.trim().toLowerCase()).length > 1;
          return (
            <div key={h.id} className="flex flex-wrap items-center gap-3 rounded-2xl bg-white border px-5 py-4" data-testid={`editor-hub-row-${h.id}`}>
              <div className="flex-1 min-w-[180px]">
                <p className="font-semibold">{h.name}</p>
                <p className="text-xs text-slate-500">{h.kind === "scan" || !sells ? "" : "Home for sale · "} {h.matterport_model_id ? "Matterport linked" : "No Matterport link yet"} · {count(h)} hotspots · {h.tour_stops?.length || 0} tour stops</p>
                {dup && <p className="text-xs text-amber-700 mt-1" data-testid={`editor-hub-dup-${h.id}`}>Same name as another item, probably the same Matterport tour added twice. Keep the one with your hotspots and delete the other.</p>}
              </div>
              <Link to={`/admin/homes/${h.id}`} data-testid={`editor-hub-setup-${h.id}`}><AdminButton variant="ghost"><ListChecks className="w-4 h-4" />{sells ? "Rooms" : t.rooms[0].toUpperCase() + t.rooms.slice(1)} & info</AdminButton></Link>
              <Link to={`/view/${h.id}?edit=1`} data-testid={`editor-hub-hotspots-${h.id}`}><AdminButton><Wand2 className="w-4 h-4" />Edit hotspots</AdminButton></Link>
              <Link to={`/view/${h.id}?edit=1&tab=tour`} data-testid={`editor-hub-tour-${h.id}`}><AdminButton variant="ghost"><Route className="w-4 h-4" />Build guided tour</AdminButton></Link>
              {content && <Link to="/admin/house-types" data-testid={`editor-hub-edit-${h.id}`}><AdminButton variant="ghost"><Pencil className="w-4 h-4" />Edit details</AdminButton></Link>}
              {content && <AdminButton variant="danger" onClick={() => del(h)} data-testid={`editor-hub-delete-${h.id}`}><Trash2 className="w-4 h-4" />Delete</AdminButton>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
